import Image from "next/image";

import { useI18n } from "utils/with-i18n.utils";

export const Label = () => {
  const i18n = useI18n();

  return (
    <div className="flex flex-col gap-6 items-center py-[30px] px-6 w-full text-center text-white bg-pastel-green-3 rounded-xl">
      <div className="flex max-w-[90%]">
        <Image
          src={"/images/environment/nr.svg"}
          alt="NR label"
          width={151}
          height={155}
        />
        <Image
          src={"/images/environment/ademe.svg"}
          alt="ADEME label"
          width={151}
          height={155}
        />
      </div>
      <div className="flex flex-col gap-6 text-[16px] leading-[30px] md:w-1/3 lg:text-[18px]">
        <p>{i18n.t("environment.co2.label", {}, { html: true })}</p>
      </div>
    </div>
  );
};
